export class CSV {
  headers: string[];
  rows: string[][];

  constructor(headers: string[] = [], rows: string[][] = []) {
    this.headers = headers;
    this.rows = rows;
  }

  setHeaders(headers: string[]) {
    this.headers = headers;
    return this;
  }

  addRow(row: string[]) {
    this.rows.push(row);
    return this;
  }

  addRows(rows: string[][]) {
    this.rows.push(...rows);
    return this;
  }

  download(name: string) {
    const csv =
      this.headers.join(', ') +
      '\n' +
      this.rows.map(row => row.map(cell => `"${(cell || '').replace(/"/g, '""')}"`).join(',')).join('\n');
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
    element.setAttribute('download', name);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
